// extracted by mini-css-extract-plugin
export default {"container":"form-actions_container__tXZ6k","truncate-table":"form-actions_truncate-table__HHon7","table-text-faded":"form-actions_table-text-faded__DZqdr","formActions":"form-actions_formActions__ryJeA","fixed":"form-actions_fixed__lkH+D","slide-in":"form-actions_slide-in__Dhi7q","wrapper":"form-actions_wrapper__WOWht","content":"form-actions_content__As1lU","buttons":"form-actions_buttons__g+oCn"};
    if(module.hot) {
      // 1793877078344
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  